import {ColDef, ICellRendererParams} from "ag-grid-community";
import AbsAGGridEditViewColumn from "@/utils/UIConstants/AGGridEditViewColumns/AbsAGGridEditViewColumn.ts";
import AGGridPasswordCellEditor from "@/components/inputs/AGGridPasswordCellEditor.vue";
import EditableGridHandler from "@/utils/presenters/EditableGridHandler.ts";
import EditScreenGridColumn = namaTypes.EditScreenGridColumn;

export default class AGGridEditViewPasswordColumn extends AbsAGGridEditViewColumn
{
  constructor(column: EditScreenGridColumn, handler: EditableGridHandler) {
    super(column, handler);
  }

  override createColDef(): ColDef[] {
    let colDef = AbsAGGridEditViewColumn.defaultColDef(this);
    colDef.cellRenderer = (params: ICellRendererParams) => '•'.repeat(params.value ? params.value.length : 0);
    colDef.cellEditor = AGGridPasswordCellEditor;
    return [colDef];
  }
}
